<div class="notif-bell">
  <!-- Bell button -->
  <button
    class="icon-btn"
    type="button"
    title="Notifications"
    [attr.aria-expanded]="isOpen()"
    aria-haspopup="dialog"
    (click)="toggle()"
  >
    <fa-icon [icon]="iconService.getIcon('notifications')" />
    @if (notifService.hasUndismissed()) {
      <span class="notification-dot"></span>
    }
  </button>

  <!-- Dropdown panel -->
  @if (isOpen()) {
    <div class="notif-bell__dropdown" role="dialog" aria-label="Notifications">
      <ams-feature-lock [locked]="!features.notificationsEnabled()" [message]="features.unavailableMessage()">

      <!-- Header -->
      <div class="notif-bell__header">
        <span class="notif-bell__title">Notifications</span>
        @if (notifService.undismissedNotifications().length > 0) {
          <button
            class="notif-bell__dismiss-all"
            type="button"
            (click)="dismissAll()"
          >
            Dismiss all
          </button>
        }
      </div>

      <!-- Notification list -->
      <div class="notif-bell__list">
        @if (notifService.undismissedNotifications().length === 0) {
          <!-- Empty state -->
          <div class="notif-bell__empty">
            <fa-icon
              class="notif-bell__empty-icon"
              [icon]="iconService.getIcon('notifications')"
              size="2x"
            />
            <span>You're all caught up!</span>
            <button
              class="notif-bell__see-all-btn"
              type="button"
              (click)="seeAll()"
            >
              See all notifications
            </button>
          </div>
        } @else {
          @for (notif of notifService.undismissedNotifications(); track notif.notificationId) {
            <div class="notif-bell__item">
              <div class="notif-bell__item-body">
                <p class="notif-bell__item-title">{{ notif.title }}</p>
                <p class="notif-bell__item-desc">{{ notif.body }}</p>
                <div class="notif-bell__item-meta">
                  @if (notif.module) {
                    <span class="notif-bell__item-module">{{ notif.module }}</span>
                  }
                  <span class="notif-bell__item-time">{{ formatTimestamp(notif.createdAt) }}</span>
                </div>
              </div>
              <button
                class="notif-bell__item-dismiss"
                type="button"
                title="Dismiss notification"
                (click)="dismiss(notif.notificationId)"
              >
                <fa-icon [icon]="iconService.getIcon('close')" />
              </button>
            </div>
          }
        }
      </div>

      <!-- Footer -->
      @if (notifService.undismissedNotifications().length > 0) {
        <div class="notif-bell__footer">
          <button
            class="notif-bell__see-all-btn"
            type="button"
            (click)="seeAll()"
          >
            See all notifications
          </button>
        </div>
      }

      </ams-feature-lock>
    </div>
  }
</div>
